import React, { useState, useEffect, memo } from 'react';
import { PivotViewComponent, PivotColumn, IDataOptions, QueryCellInfoEventArgs, ConditionalFormatting, IDataSet, CalculatedField, PDFExport, pdfQueryCellInfo, FieldList, Inject, Toolbar, ToolbarArgs, RemoveReportArgs, LoadReportArgs, RenameReportArgs, SaveReportArgs, FetchReportArgs } from '@syncfusion/ej2-react-pivotview';
import { ButtonComponent } from "@syncfusion/ej2-react-buttons";
import { getValue } from '@syncfusion/ej2-base';
import '../style.css';
// import { image } from './image';
// import { imageDigital } from './imageDigital';
import { PdfHeaderQueryCellInfoEventArgs, PdfQueryCellInfoEventArgs, Column, Aggregate } from '@syncfusion/ej2-react-grids';
import { NotificacaoInterna } from '../../../../../Services/Notification';
import { useHistory } from "react-router-dom";
import { Moeda } from '../../../../../Themes/TextFormat'
import apiAdonis from '../../../../../Services/adonis';
import { api } from '../../../Services/api';
import moment from 'moment';
import { Button, FormGroup, Icon, MenuItem, Checkbox, Collapse, Divider } from '@blueprintjs/core';
import { PdfPaddings } from '@syncfusion/ej2-pdf-export';

function App({ dados, saldoInicial, dataInicial, dataFinal }: any) {
  const History = useHistory();
  async function VerifyToken() {

    await apiAdonis.post('/verify', {}, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(async result => {
      if (result.data.check) {
        return null
      }
      else {
        NotificacaoInterna.ExibirNotificacao("Acesso Expirado!", "Seu acesso à aplicação foi expirado!", NotificacaoInterna.TipoDeNotificacao.Informacao);
        History.replace("/");
        window.location.reload();
      }
    });
  }

  const [getData, setData] = useState(dados);
  const [getCollapse, setCollapse] = useState<boolean>(false);
  const [getExpandAll, setExpandAll] = useState<boolean>(false);
  let pivotObj: PivotViewComponent;

  let dataSourceSettings: IDataOptions = {
    enableSorting: true,
    columns: [{ name: 'Ano' }, { name: 'MesAno' }],
    valueSortSettings: { headerDelimiter: ' - ' },
    values: [{ name: 'ValorRec', caption: 'Valor Recebido' } /*, { name: 'Amount', caption: 'Sold Amount' }*/],
    dataSource: getData,
    rows: [{ name: 'GRUPO'/*'Natureza'*/, caption: 'Natureza'/*'Natureza'*/ }, { name: 'Divisao'/*'Natureza'*/, caption: 'Divisao'/*'Natureza'*/ }, { name: 'TIPO'/*'Natureza'*/, caption: 'Tipo'/*'Natureza'*/ }, { name: 'categoria', caption: 'Categoria' }],
    formatSettings: [{ name: 'ValorRec', format: 'C2' }, { name: 'MesAno', type: 'date', format: "MM/yyyy" }, { name: 'Data Compensacao', type: 'date', format: "dd/MM/yyyy" }],
    expandAll: getExpandAll,
    filters: [{ name: 'MesAno', caption: 'mesano' }],
    showGrandTotals: true
  };

  useEffect(() => {
    async function componentDidMount() {
      await VerifyToken();
      if (dados !== undefined) {

        let data = JSON.parse(JSON.stringify(dados).replace(/GRUPO/g, /*'Natureza'*/'GRUPO').replace(/KEY_CDEMP_CDOBR_BD/g, 'Nome obra'));

        console.log(data)

        await setData(data);
      }
    }
    componentDidMount();
  }, [dados, saldoInicial])
  const saveReport = (args: any) => {
    let reports: SaveReportArgs[] = [];
    let isSaved: boolean = false;
    if (localStorage.pivotviewReports && localStorage.pivotviewReports !== "") {
      reports = JSON.parse(localStorage.pivotviewReports);
    }
    if (args.report && args.reportName && args.reportName !== '') {
      reports.map(function (item: any): any {
        if (args.reportName === item.reportName) {
          item.report = args.report; isSaved = true;
        }
      });
      if (!isSaved) {
        reports.push(args);
      }
      localStorage.pivotviewReports = JSON.stringify(reports);
      console.log('saveReport: ' + localStorage.pivotviewReports);
    }
  }
  const beforeToolbarRender = (args: ToolbarArgs | any) => {
    args.customToolbar.splice(6, 0, {
      type: 'Separator'
    });
    args.customToolbar.splice(9, 0, {
      type: 'Separator'
    });
  }
  const fetchReport = (args: FetchReportArgs | any) => {
    let reportCollection: string[] = [];
    let reeportList: string[] = [];
    if (localStorage.pivotviewReports && localStorage.pivotviewReports !== "") {
      reportCollection = JSON.parse(localStorage.pivotviewReports);
      console.log('reportCollection(fetchReport): ' + reportCollection)
    }
    reportCollection.map(function (item: any): void { reeportList.push(item.reportName); });
    args.reportName = reeportList;
  }
  const loadReport = (args: LoadReportArgs | any) => {
    let reportCollection: string[] = [];
    if (localStorage.pivotviewReports && localStorage.pivotviewReports !== "") {
      reportCollection = JSON.parse(localStorage.pivotviewReports);
      console.log('reportCollection(loadReport): ' + reportCollection)
    }
    reportCollection.map(function (item: any): void {
      if (args.reportName === item.reportName) {
        args.report = item.report;
        console.log('args.report(loadReport): ' + args.report)
      }
    })
    if (args.report) {
      pivotObj.dataSourceSettings = JSON.parse(args.report).dataSourceSettings;
      console.log('pivotObj.dataSourceSettings(loadReport): ' + dataSourceSettings)
    }
  }
  const removeReport = (args: RemoveReportArgs | any) => {
    let reportCollection: any[] = [];
    if (localStorage.pivotviewReports && localStorage.pivotviewReports !== "") {
      reportCollection = JSON.parse(localStorage.pivotviewReports);
      console.log('reportCollection(removeReport): ' + reportCollection)
    }
    for (let i: number = 0; i < reportCollection.length; i++) {
      if (reportCollection[i].reportName === args.reportName) {
        reportCollection.splice(i, 1);
        console.log('reportCollection(removeReport): ' + reportCollection)
      }
    }
    if (localStorage.pivotviewReports && localStorage.pivotviewReports !== "") {
      localStorage.pivotviewReports = JSON.stringify(reportCollection);
      console.log('localStorage.pivotviewReports(removeReport): ' + localStorage.pivotviewReports)
    }
  }
  const renameReport = (args: RenameReportArgs | any) => {
    let reportsCollection: any[] = [];
    if (localStorage.pivotviewReports && localStorage.pivotviewReports !== "") {
      reportsCollection = JSON.parse(localStorage.pivotviewReports);
      console.log('reportsCollection(removeReport): ' + reportsCollection)
    }
    if (args.isReportExists) {
      for (let i: number = 0; i < reportsCollection.length; i++) {
        if (reportsCollection[i].reportName === args.rename) {
          reportsCollection.splice(i, 1);
          console.log('reportsCollection(removeReport): ' + reportsCollection)
        }
      }
    }
    reportsCollection.map(function (item: any): any { if (args.reportName === item.reportName) { item.reportName = args.rename; } });
    if (localStorage.pivotviewReports && localStorage.pivotviewReports !== "") {
      localStorage.pivotviewReports = JSON.stringify(reportsCollection);
      console.log('reportsCollection(removeReport): ' + reportsCollection)
    }
  }
  const newReport = () => {
    pivotObj.setProperties({ dataSourceSettings: { columns: [], rows: [], values: [], filters: [] } }, false);
  }
  const pdfQueryCellInfo = (args: PdfQueryCellInfoEventArgs) => {
    
  }
  const pdfHeaderQueryCellInfo = (args: PdfHeaderQueryCellInfoEventArgs | any) => {
    (args.cell as any).row.pdfGrid.repeatHeader = true;
    args.cell.gridRow.pdfGrid.columns.getColumn(0).width = 200;
    args.cell.gridRow.pdfGrid.columns.getColumn(1).textAlign = "Right";
  }
  function btnClick() {
    pivotObj.pdfExport({
      pageOrientation: "Portrait",
      exportType: 'AllPages',
      theme: {
        header: { fontSize: 5, bold: true },
        record: { fontSize: 5 },
        caption: { bold: false }
      },
      header: {
        fromTop: 0,
        height: 100,
        contents: [
          // {
          //   position: { x: 0, y: 0 },
          //   size: { height: 70, width: 100 },
          //   src: image,
          //   type: 'Image',
          // },
          {
            type: 'Text',
            value: `FLUXO DE CAIXA`,
            position: { x: 0, y: 0 },
            style: { textBrushColor: '#000000', fontSize: 20 }
          },
          {
            type: 'Text',
            value: `ESPAÇO PARTICIPAÇÕES`,
            position: { x: 0, y: 20 },
            style: { textBrushColor: '#000000', fontSize: 13 }
          },
          {
            type: 'Text',
            value: `De ${moment(dataInicial).format('DD/MM/YYYY')} até ${moment(dataFinal).format('DD/MM/YYYY')}`,
            position: { x: 0, y: 35 },
            style: { textBrushColor: '#000000', fontSize: 13 }
          }
        ]
      },
      footer: {
        fromBottom: 0,
        height: 50,
        contents: [
          {
            type: 'PageNumber',
            pageNumberType: 'Arabic',
            format: 'Page {$current} of {$total}',
            position: { x: 0, y: 25 },
            style: { textBrushColor: '#000000', fontSize: 15 }
          },
          {
            type: 'Text',
            value: "Powered By",
            position: { x: 230, y: 30 },
            style: { textBrushColor: '#000000', fontSize: 13, dashStyle: 'Solid', hAlign: 'Center' }
          },
          // {
          //   position: { x: 300, y: 30 },
          //   style: { hAlign: 'Center' },
          //   size: { height: 15, width: 70 },
          //   src: imageDigital,
          //   type: 'Image',
          // }
        ]
      },
      allowHorizontalOverflow: false
    });
  }
  function btnClickExcel() {
    pivotObj.excelExport()
  }
  function queryCellInfo(args: QueryCellInfoEventArgs) {
    
  }

  return (
    <>
      <div className='control-pane' style={{ width: "100%" }}>
        <div className='control-section' style={{ overflow: 'auto', width: "100%" }}>
          <PivotViewComponent
            ref={(d) => (d != null ? pivotObj = d : null)}
            id='PivotView'
            dataSourceSettings={dataSourceSettings}
            showToolbar={true}
            gridSettings={{ columnWidth: 140, allowTextWrap: false }}
            allowConditionalFormatting={true}
            allowExcelExport={true}
            allowPdfExport={true}
            toolbar={["FieldList"/*,'New', 'Save', 'SaveAs', 'Rename', 'Remove', 'Load'*/]}
            toolbarRender={beforeToolbarRender}
            pdfHeaderQueryCellInfo={pdfHeaderQueryCellInfo}
            pdfQueryCellInfo={pdfQueryCellInfo}
            queryCellInfo={queryCellInfo}
            height={700}
            locale='pt-BR'
            style={{ maxWidth: "100%", overflow: "auto" }}
            allowCalculatedField={true}
            showFieldList={true}
            newReport={newReport}
            renameReport={renameReport}
            removeReport={removeReport}
            loadReport={loadReport}
            fetchReport={fetchReport}
            saveReport={saveReport}
          >
            <Inject services={[FieldList, CalculatedField, Toolbar, ConditionalFormatting]} />
          </PivotViewComponent>
        </div>
        {/* Buttons */}
        <div style={{ display: "flex" }}>
          <div className="col-lg-3 property-section">
            <ButtonComponent
              cssClass="e-primary"
              style={{ border: "none", boxShadow: "unset", width: "202px", height: "30px", borderRadius: "unset", marginRight: "20px" }}
              onClick={() => setExpandAll(!getExpandAll)}
            >
              EXPANDIR/RECOLHER
            </ButtonComponent>
            {/* <button onClick={() => console.log(dataSourceSettings)}>Button</button> */}
          </div>
          <div style={{ height: getCollapse ? "70px" : "unset" }}>
            <div onClick={() => setCollapse(!getCollapse)} style={{ width: "202px", height: "30px", cursor: "pointer", marginBottom: getCollapse ? "20px" : "unset", background: "#d637a7", color: "#fff", display: "flex", alignItems: "center", justifyContent: "center" }}>EXPORTAR</div>
            <Collapse isOpen={getCollapse}>
              <div style={{ display: "flex", flexDirection: "column", width: "202px", height: "70px", justifyContent: "space-between" }}>
                <div className="col-lg-3 property-section">
                  <ButtonComponent
                    cssClass="e-primary"
                    style={{ border: "none", boxShadow: "unset", width: "202px", marginRight: "20px" }}
                    onClick={() => { btnClick() }}
                  >
                    PDF
                  </ButtonComponent>
                  {/* <button onClick={() => console.log(dataSourceSettings)}>Button</button> */}
                </div>
                <div className="col-lg-3 property-section">
                  <ButtonComponent
                    cssClass="e-primary"
                    style={{ border: "none", boxShadow: "unset", width: "202px" }}
                    onClick={() => { btnClickExcel() }}
                  >
                    EXCEL
                  </ButtonComponent>
                  {/* <button onClick={() => console.log(dataSourceSettings)}>Button</button> */}
                </div>
              </div>
            </Collapse>
          </div>
        </div>
      </div>
    </>
  );
}

export default memo(App);